<div>
    <app-header
        title="New claim registration"
        backLinkText="Back to my quality claims"
    />

    <div class="">
        <div>
            <app-progress-bar
                [steps]="[ {title: 'Claim details'}, { title: 'Claim materials' } ]"
                [currentStep]="2"
            />
        </div>

        <div class="flex flex-col md:flex-row">
            <div class="bg-white">
                Hola caracola
            </div>

            <div class="bg-background-medium-02">

            </div>
        </div>
    </div>
</div>
